import React from 'react';

import { Stack, StackProps } from '../Stack/Stack';

export type ActionBarProps = StackProps & {
  actions: React.ReactNode;
};

export const ActionBar = (props: ActionBarProps) => {
  const { actions, ...stackProps } = props;

  return (
    <Stack direction='row' alignItems='center' padding={1} useFlexGap spacing={2} minHeight='48px' {...stackProps}>
      {actions}
    </Stack>
  );
};
